import React, { useEffect, useState } from "react";
import {Col,Form,Row} from "react-bootstrap";
import {  createOption } from "./createableSelect";
import "rsuite/dist/rsuite.min.css";
import DatePicker from "react-datepicker";
import CustomSelect from "components/CustomSelect";
import { FaTrash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { Box } from "@chakra-ui/react";
import { getOptionDataOnEdit } from "jsFunctions/calculateGst";
import VendorCustomSelect from "./Vendors/VendorCustomSelect";
import { allPaymentMode } from "./PurchaseItem/selectedOptions";
import useFormOptions from "hooks/FormOptions/useFormOptions";
import useOrganizationData from "hooks/organizaton/useOrganization";
import DrawerButton from "./component/buttons/drawerButton";


const RefundInfoListComponent = ({ getData, autoCount,refundAmountError,remainingAmount, editData,paymentData , deleteMultipleListItem,expenseType, role}) => {
  const [payeeValue, setPayeeValue] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [bankValue, setBankValue] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
 
  const [preAmount, setPreAmount] = useState(0)

  const {organizationData} = useOrganizationData();
  
  const {
    formOptionsList,
    payeeOption,
    bankOption,
    createNewFormOption,
    deleteFromOption,
    editFormOption,
  } = useFormOptions(expenseType);


  useEffect(()=>{
    const data = editData?.rfdInfo?.list[autoCount]
    const amount = data?.amt ? data?.amt : 0
    setPreAmount(amount)
  },[editData,autoCount])


  useEffect(() => {
    if (paymentData  && formOptionsList.length > 0) {
      const payeeData = getOptionDataOnEdit(
        formOptionsList,
        paymentData?.pyId?._id || paymentData?._id,         
        "payee",
      );

      if (payeeData && payeeData?._id) {
        setPayeeValue({
          label: payeeData.lab,
          value: payeeData.val,
          id: payeeData?._id
        });
      }
      else if(!paymentData?.pyId){
        const orgName = organizationData?.name || ""
        const defaultPay = formOptionsList.find(option => 
          option.val.toLowerCase().includes(orgName.toLowerCase()) && option.typ === 'payee'
        );
        
        if(defaultPay && defaultPay?._id){
          getData({pyId:defaultPay?._id})
          setPayeeValue({
            label: defaultPay.lab,
            value: defaultPay.val,
            id: defaultPay?._id
          });
        }
      }
     
      const bakData = getOptionDataOnEdit(
        formOptionsList,
        paymentData?.bnkId?._id,         
        "bank",
    );
    if (bakData && bakData?._id) {
      setBankValue({
        label: bakData.lab,
        value: bakData.val,
        id: bakData?._id
      });
    }
    else if(!paymentData?.bnkId){
      const defaultBank = formOptionsList.find(option => 
        option.val.toLowerCase().includes("icici") && option.typ === 'bank'
      );
      
      if(defaultBank && defaultBank?._id){
        getData({bnkId:defaultBank?._id})
        setBankValue({
          label: defaultBank.lab,
          value: defaultBank.val,
          id: defaultBank?._id
        });
      }
    }
      setPaymentAmount(paymentData?.amt);
      if(paymentData?.moId){
        const payMod = allPaymentMode.find(opt=> opt.id === paymentData?.moId)
        setPaymentMode(payMod)
      }
    }
    if(!paymentData?.pmtDt){
      getData({pmtDt:new Date()})
    }
    
  }, [formOptionsList,paymentData,organizationData]);
  
  useEffect(()=>{
    if (!paymentData?._id){
      setPaymentAmount(remainingAmount)
      getData({ amt: remainingAmount });
    }
  },[remainingAmount])


  return (
    <div className={`${addTogglePaymentIdx ? "show" : "hide"}`}>
      <div className="payment-list_array mt-3">
        <div className="d-flex">
          <span className="payment-details">
            Refund Details {autoCount + 1}
          </span>
        </div>
        <div className="d-flex toggleImage-content">
        <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
        {["Admin", "Manager", "Accountant"].includes(role) &&
        preAmount !== 0 ? (
          <div className="d-flex" onClick={() => deleteMultipleListItem()}>
            <span className="mt">
              <FaTrash
                style={{
                  fontSize: "16px",
                  color: "red",
                  cursor: "pointer",
                }}
              />
            </span>
          </div>
        ) : (
          preAmount === 0 && (
            <div className="d-flex" onClick={() => deleteMultipleListItem()}>
              <span className="mt">
                <FaTrash
                  style={{
                    fontSize: "16px",
                    color: "red",
                    cursor: "pointer",
                  }}
                />
              </span>
            </div>
          )
        )}
      </div>

      <div
        className={`payment-inner_box ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Refund Amount <span className="span-star">*</span>
              </Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <span className="rupee-symbol">₹</span>{" "}
                </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  defaultValue={paymentAmount}
                  value={paymentAmount || ""}
                  onValueChange={(e) => {
                    getData({ amt: e.value });
                    setPaymentAmount(e.value)
                  }}
                  thousandSeparator={true}
                  // prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </InputGroup>
            </Box>
            <p className="form_error">
              {" "}
              {refundAmountError[`refund.${autoCount}.amount`]}
            </p>
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>Payment Mode</Form.Label>
              <VendorCustomSelect
                options={allPaymentMode}
                placeHolder={<div>Type or select...</div>}
                onChange={(newValue) => {
                  getData({ moId: newValue?.id });
                  setPaymentMode(newValue);
                }}
                isSearchable
                defaultValue={paymentMode}
                role={role}
              />
              </Box>
          </Col>
        </Row>
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Payee <span className="span-star">*</span>
              </Form.Label>
              <CustomSelect
                options={payeeOption}
                placeHolder={<div>Type or select...</div>}
                onChange={(newValue) => {
                  getData({ pyId: newValue?.id });
                  setPayeeValue(newValue);
                }}
                isSearchable
                onCreateOption={(e) => {
                  createNewFormOption(createOption(e), "payee");
                }}
                onDeleteOption={(option) => {
                  deleteFromOption(option, "payee");
                }}
                onEditOption={(option, newValue) => {
                  editFormOption(option, newValue, "payee");
                }}
                defaultValue={payeeValue}
                role={role}
              />
            </Box>
            <p className="form_error">
              {" "}
              {refundAmountError[`refund.${autoCount}.payeeId`]}
            </p>
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>Bank</Form.Label>
              <CustomSelect
                options={bankOption}
                placeHolder={<div>Type or select...</div>}
                onChange={(newValue) => {
                  getData({ bnkId: newValue?.id });
                  setBankValue(newValue);
                }}
                isSearchable
                onCreateOption={(e) => {
                  createNewFormOption(createOption(e), "bank");
                }}
                onDeleteOption={(option) => {
                  deleteFromOption(option, "bank");
                }}
                onEditOption={(option, newValue) => {
                  editFormOption(option, newValue, "bank");
                }}
                defaultValue={bankValue}
                role={role}
              />
            </Box>
          </Col>
        </Row>
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Reference Number <span className="span-star">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="referenceNo"
                placeholder="Reference Number"
                onChange={(e) => {
                  getData({ rfNo: e.target.value });
                }}
                defaultValue={paymentData?.rfNo}
              />
            </Box>
            <p className="form_error">
              {" "}
              {refundAmountError[`refund.${autoCount}.refNo`]}
            </p>
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Date <span className="span-star">*</span>
              </Form.Label>
              <Box>
                <DatePicker
                  name="paymentdate"
                  className="monthDate"
                  dateFormat="dd-MMM-yyyy"
                  selected={
                    paymentData?.pmtDt
                      ? new Date(paymentData.pmtDt)
                      : new Date()
                  }
                  onChange={(date) => {
                    getData({ pmtDt: date });
                  }}
                  
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </Box>
            </Box>
            <p className="form_error">
              {" "}
              {refundAmountError[`refund.${autoCount}.paymentDate`]}
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RefundInfoListComponent;
